import { ActionType } from "../interfaces/api/actionType";

export const GetSalaryExpectations: ActionType = {
  FAILURE: "GET_SALARY_EXPECTATIONS_FAILURE",
  REQUEST: "GET_SALARY_EXPECTATIONS_REQUEST",
  SUCCESS: "GET_SALARY_EXPECTATIONS_SUCCESS",
};
